import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiErrorHandlerProvider} from "../api-error-handler/api-error-handler";

@Injectable()
export class StaffServiceProvider {

  constructor(
    public http: HttpClient,
    private apiErrorHandler: ApiErrorHandlerProvider,
  ) {
  }

  getStaff(staffId) {
    return new Promise((resolve, reject) => {
      this.http.get(`/staff/${staffId}`).subscribe((staff: any) => {
        resolve(staff);
      }, error => {
        this.apiErrorHandler.handleError(error);
        reject(error)
      })
    })
  }

  getStaffWithBookings(teamId, staffId) {
    return new Promise((resolve, reject) => {
      this.http.get(`/teams/${teamId}/bookings/byStaff/${staffId}`).subscribe((staff: any) => {
        resolve(staff);
      }, error => {
        this.apiErrorHandler.handleError(error);
        reject(error)
      })
    })
  }

  toggleCheckIn(event, currentTeamId, staffId) {
    return new Promise((resolve, reject) => {
      this.http.post(`/teams/${currentTeamId}/members/${staffId}/logIntoTeam`, {
        login: event
      }).subscribe(res => {
        resolve(res)
      }, error => {
        this.apiErrorHandler.handleError(error);
        reject(error)
      })
    });
  }

  checkInOutToggle(staff, teamId) {
    return staff.current_active_team == teamId ? true : false;
  };

  isStaffUnavailable(shopId, staff) {
    if (staff.queue_status === 0 && staff.queue_full === 0) return true;
    if (staff.current_active_team !== shopId && staff.queue_full === 0) return true;
    return false;
  }

  isStaffQueueFull(staff, shopId) {
    if (staff.queue_full === 1 && staff.current_active_team === shopId && staff.current_queue_length === staff.current_queue_length_with_cancelled) return true;
    return false;
  }

  isStaffAvailableAndQueueFull(staff, shopId) {
    if (staff.queue_status === 1 && staff.queue_full === 1 && staff.current_active_team === shopId && staff.current_queue_length === staff.current_queue_length_with_cancelled) return true;
    return false;
  }

  isCurrentlyActiveStaff(shopId, staff, index) {
    if (index === 0 && staff.queue_full === 0 && staff.queue_status === 1 && staff.current_active_team === shopId) return true;
    return false;
  }

  getQueueClass(shopId, staff, index) {
    if (this.isCurrentlyActiveStaff(shopId, staff, index)) return 'card-queue--highlight';
    if (this.isStaffAvailableAndQueueFull(staff, shopId)) return 'card-queue--full';
    if (this.isStaffQueueFull(staff, shopId)) return 'card-queue--full';
    if (this.isStaffUnavailable(shopId, staff)) return '';
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/providers/staff-service/staff-service.ts